import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {routes} from "../../../../../../core/models/static/routes/app-routes";
import useAccessLevels from "../../../../../hooks/use-access-levels";
import PurchaseHistoryListView from "./list";
import PurchaseHistorySingleView from "./single";

/**
 * History routes: list on system + vendor bases; single only under vendor.
 */
const PurchaseHistoryViews = () => {
    const operatorAccessLevels = useAccessLevels();

    return (
        <Switch>
            {
                operatorAccessLevels.packages.purchasing.viewPurchaseHistory &&
                <Route path={routes.vendor.purchases.history.single} exact>
                    <PurchaseHistorySingleView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.purchasing.viewPurchaseHistory &&
                <Route path={[
                    routes.purchase.history,
                    routes.vendor.purchases.history.base,
                ]} exact>
                    <PurchaseHistoryListView/>
                </Route>
            }
            <Redirect to={routes.purchase.history.concat(routes.error.serverErrorForSection)}/>
        </Switch>
    );
};

export default PurchaseHistoryViews;
